import React from "react";
import { useWeb3React } from "@web3-react/core";
import { CardContainer } from "../styled/Card";
import { FormHeadline, FormParagraph } from "../styled/Form";
import { Row } from "../styled/Flex";
import Button from "../styled/Button";
import styled from "styled-components";
import { injected } from "../../config/walletConnectors";
import { isUnsupportedNetwork } from "../../config/web3";
const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 65px;
  margin-bottom: 65px;
`;

const WalletForm = (props: Props) => {
  const { account, activate, chainId } = useWeb3React();
  const activateWallet = () => {
    activate(injected);
  };

  if (chainId && isUnsupportedNetwork(chainId)) {
    return (
      <CardContainer {...props}>
        <InfoContainer>
          <Group>
            <FormHeadline textAlign="center">Unsupported chain</FormHeadline>
            <FormParagraph textAlign="center">
              You are connected to an unsupported network. Please switch to a
              supported network.
            </FormParagraph>
          </Group>
        </InfoContainer>
      </CardContainer>
    );
  }

  return (
    <CardContainer {...props}>
      {account && !isUnsupportedNetwork(chainId) ? (
        props.children
      ) : (
        <InfoContainer>
          <Group>
            <FormHeadline textAlign="center">Attention</FormHeadline>
            <FormParagraph textAlign="center">
              In order to use the app, and relaunch the token you need an active
              wallet connection. Please connect your wallet
            </FormParagraph>
          </Group>
          <Row>
            <Button onClick={() => activateWallet()}>Connect Wallet</Button>
          </Row>
        </InfoContainer>
      )}
    </CardContainer>
  );
};

type Props = React.ComponentProps<typeof CardContainer>;

export default WalletForm;
